export default __webpack_public_path__ + "static/media/java.d31ae851.svg";